import { UrlUtils } from '@wix/package-picker-shared';
import { useCallback } from 'react';
import { useCurrentModule } from '../../components';

/**
 * Aligned with legacy premium-purchase-plan logic.
 * Legacy default: `//users.wix.com/signin?postLogin=https://www.wix.com/store/plans`
 * Note: No locale-specific URLs for regular Wix (only Studio uses locale-specific).
 */
const DEFAULT_POST_LOGIN_URL = 'https://www.wix.com/store/plans';
const DEFAULT_POST_SIGN_UP_URL = 'https://www.wix.com/store/plans';

/**
 * loginDialogContext options (from wix-users-statics):
 * - 'login' - Opens login dialog in login mode
 * - 'signup' - Opens login dialog in signup mode (default)
 */

export const useAnonymous = () => {
  const module = useCurrentModule();
  const {
    userId
  } = module.internals.useContext();
  const isAnonymous = !userId;

  /**
   * Builds sign-in redirection link aligned with legacy premium-purchase-plan logic.
   *
   * Default output: `//users.wix.com/signin?loginDialogContext=signup&postLogin=...&postSignUp=...`
   */
  const buildSignInRedirectionLink = useCallback(options => {
    const params = {
      loginDialogContext: (options == null ? void 0 : options.loginDialogContext) ?? 'signup',
      postLogin: (options == null ? void 0 : options.postLoginUrl) ?? DEFAULT_POST_LOGIN_URL,
      postSignUp: (options == null ? void 0 : options.postSignUpUrl) ?? DEFAULT_POST_SIGN_UP_URL
    };
    return UrlUtils.buildUrl({
      url: '//users.wix.com/signin',
      params
    });
  }, []);
  return {
    isAnonymous,
    buildSignInRedirectionLink
  };
};
//# sourceMappingURL=useAnonymous.js.map